const MainView = require('./main-view.js')


module.exports = function BendingView(state, emit) {
//  emit('set-playing-tutorial', false)
  return MainView(state, emit)
}
